export const BLACK_THEMED_PAGES = ['/team', '/careers'];
